import {LayoutComponent} from "../layout/layout.component";
import {RouterModule, Routes} from "@angular/router";
import {NgModule} from "@angular/core";
import {ForgotPasswordComponent} from "./forgot-password.component";

const routes: Routes = [
  {
    path: 'forgot-password',
    component: LayoutComponent,
    children: [
      {
        path: '',
        component: ForgotPasswordComponent,
      }
    ]
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ForgotPasswordRoutingModule { }
